import { useState } from "react"
import { MapPin } from "lucide-react"
import { businessInfo, googleMapsEmbedUrl } from "@/lib/business-info"

export function LazyGoogleMap() {
  const [isLoaded, setIsLoaded] = useState(false)

  if (!isLoaded) {
    return (
      <button
        type="button"
        onClick={() => setIsLoaded(true)}
        className="group relative flex h-[400px] w-full flex-col items-center justify-center gap-4 overflow-hidden rounded-2xl border border-border/50 bg-[radial-gradient(circle_at_top,rgba(34,197,94,0.14),transparent_55%),linear-gradient(160deg,rgba(10,10,10,0.04),rgba(34,197,94,0.08))] p-8 text-center transition-colors hover:border-zielarz-green/40"
      >
        <div className="flex size-14 items-center justify-center rounded-full border border-zielarz-green/30 bg-zielarz-green/10">
          <MapPin className="size-7 text-zielarz-green" />
        </div>
        <div>
          <p className="text-lg font-bold">{businessInfo.name}</p>
          <p className="mt-2 text-sm text-muted-foreground">
            {businessInfo.address.streetAddress},{" "}
            {businessInfo.address.postalCode}{" "}
            {businessInfo.address.addressLocality}
          </p>
          <p className="mt-4 text-sm font-semibold text-zielarz-green group-hover:underline">
            Kliknij, aby zaladowac mape Google
          </p>
        </div>
      </button>
    )
  }

  return (
    <iframe
      src={googleMapsEmbedUrl}
      width="100%"
      height="400"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title={`${businessInfo.name} - lokalizacja`}
    />
  )
}
